(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kinetics-announcement"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-kx-ann]').forEach(function(track){
      var msgs = track.querySelectorAll('.kx-ann__msg');
      if(msgs.length < 2) return;
      var i = 0;
      setInterval(function(){
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, 4200);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinetics-blog-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.kx-blog').forEach(function(sec){
      var track = sec.querySelector('[data-kx-track]');
      if(!track) return;
      sec.querySelectorAll('[data-kx-scroll]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var dir = parseInt(btn.getAttribute('data-kx-scroll'), 10);
          var card = track.querySelector('.kx-blog__card');
          var w = card ? card.offsetWidth + 24 : 360;
          track.scrollBy({ left: dir * w, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinetics-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.kxRot) return;
      var slides = root.querySelectorAll('.kx-rot__slide');
      var dots = root.querySelectorAll('[data-kx-rot-dot]');
      var speed = parseInt(root.getAttribute('data-speed'), 10) || 7000;
      var cur = 0, timer = null, held = false;

      function go(i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === cur); });
      }
      function stop() { clearInterval(timer); timer = null; }
      function play() {
        stop();
        if (held || document.hidden) return;
        timer = setInterval(function () { go(cur + 1); }, speed);
      }

      root.querySelector('[data-kx-rot-prev]').addEventListener('click', function () { go(cur - 1); play(); });
      root.querySelector('[data-kx-rot-next]').addEventListener('click', function () { go(cur + 1); play(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-kx-rot-dot'), 10)); play(); });
      });
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', play);

      root.kxRot = {
        show: function (el) {
          var i = Array.prototype.indexOf.call(slides, el);
          if (i < 0) return;
          held = true; stop(); go(i);
        },
        release: function () { held = false; play(); }
      };
      play();
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-kx-rot]').forEach(init); }
    initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest && e.target.closest('.kx-rot__slide');
      var root = slide && slide.closest('[data-kx-rot]');
      if (root && root.kxRot) root.kxRot.show(slide);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest && e.target.closest('[data-kx-rot]');
      if (root && root.kxRot) root.kxRot.release();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinetics-media-band"] && !Shopify.designMode) return;
  try {
    
  // Attaches the source only once the player is within a screen of the viewport.
  // rootMargin is a full viewport height so the file has a head start and the
  // poster is never caught mid-swap.
  (function () {
    function attach(v) {
      if (v.dataset.kxLoaded) return;
      v.dataset.kxLoaded = '1';
      var s = document.createElement('source');
      s.src = v.dataset.kxSrc;
      s.type = 'video/mp4';
      v.appendChild(s);
      v.load();
      if (v.dataset.kxAutoplay) {
        // Autoplay is only permitted while muted, and a rejected promise here is
        // a browser policy decision, not an error. The poster stays put.
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    function init() {
      var vids = document.querySelectorAll('video[data-kx-lazyvid]');
      if (!vids.length) return;

      if (!('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(vids, attach);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          attach(e.target);
          io.unobserve(e.target);
        });
      }, { rootMargin: '100% 0px' });

      Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Theme editor re-renders a section without reloading the page.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinetics-quiz"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-kx-quiz]').forEach(function(root){
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-kx-step]'));
      var track = Array.prototype.slice.call(root.querySelectorAll('[data-kx-track]'));
      var result = root.querySelector('[data-kx-result]');
      var bar = root.querySelector('[data-kx-quiz-bar]');
      var cta = root.querySelector('[data-kx-result-cta]');
      var picks = root.querySelector('[data-kx-picks]');
      var fallback = cta ? cta.getAttribute('data-kx-fallback') : '';
      var total = steps.length;
      var cur = 0;
      var answers = [];

      var rules = (root.getAttribute('data-kx-routes') || '').split('\n').map(function(line){
        var at = line.indexOf('=');
        if(at === -1) return null;
        var tokens = line.slice(0, at).split('+').map(function(t){ return t.trim().toLowerCase(); }).filter(Boolean);
        var url = line.slice(at + 1).trim();
        if(!tokens.length || !url) return null;
        return { tokens: tokens, url: url };
      }).filter(Boolean);

      function destination(){
        var values = answers.filter(Boolean).map(function(a){ return a.value; }).filter(Boolean);
        for(var i = 0; i < rules.length; i++){
          var hit = rules[i].tokens.every(function(t){ return values.indexOf(t) !== -1; });
          if(hit) return rules[i].url;
        }
        var withUrl = answers.filter(Boolean).filter(function(a){ return a.url; });
        if(withUrl.length) return withUrl[withUrl.length - 1].url;
        return fallback;
      }

      function paintTrack(active){
        track.forEach(function(item, i){
          var answered = !!answers[i];
          item.classList.toggle('is-current', i === active);
          item.classList.toggle('is-done', answered && i !== active);
          var slot = item.querySelector('[data-kx-track-answer]');
          if(slot) slot.textContent = answered ? answers[i].label : '';
          var btn = item.querySelector('[data-kx-jump]');
          if(btn) btn.disabled = !answered;
        });
      }

      function show(i){
        steps.forEach(function(s){ s.classList.remove('is-on'); });
        if(result){ result.classList.remove('is-on'); result.hidden = true; }
        root.classList.toggle('is-result', i >= total);
        if(i >= total){
          if(cta) cta.setAttribute('href', destination());
          if(picks){
            picks.textContent = '';
            answers.filter(Boolean).forEach(function(a){
              var li = document.createElement('li');
              li.textContent = a.label;
              picks.appendChild(li);
            });
          }
          if(result){ result.hidden = false; result.classList.add('is-on'); }
          if(bar) bar.style.width = '100%';
          paintTrack(-1);
          return;
        }
        steps[i].classList.add('is-on');
        if(bar) bar.style.width = Math.max(5, i / total * 100) + '%';
        paintTrack(i);
      }

      steps.forEach(function(step, idx){
        step.querySelectorAll('[data-kx-opt]').forEach(function(btn){
          btn.addEventListener('click', function(){
            step.querySelectorAll('[data-kx-opt]').forEach(function(o){ o.classList.remove('is-picked'); });
            btn.classList.add('is-picked');
            var label = btn.querySelector('.kx-quiz__opt-label');
            answers[idx] = {
              label: (label ? label.textContent : btn.textContent).trim(),
              value: (btn.getAttribute('data-kx-value') || '').trim().toLowerCase(),
              url: btn.getAttribute('data-kx-url') || ''
            };
            cur = idx + 1;
            show(cur);
          });
        });
        var back = step.querySelector('[data-kx-back]');
        if(back) back.addEventListener('click', function(){ cur = Math.max(0, idx - 1); show(cur); });
      });

      track.forEach(function(item){
        var btn = item.querySelector('[data-kx-jump]');
        if(!btn) return;
        btn.addEventListener('click', function(){
          if(btn.disabled) return;
          cur = parseInt(btn.getAttribute('data-kx-jump'), 10) || 0;
          show(cur);
        });
      });

      var restart = root.querySelector('[data-kx-restart]');
      if(restart) restart.addEventListener('click', function(){
        answers = [];
        root.querySelectorAll('[data-kx-opt]').forEach(function(o){ o.classList.remove('is-picked'); });
        if(picks) picks.textContent = '';
        cur = 0;
        show(0);
      });

      show(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinetics-routine"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-routine]').forEach(function (root) {
    var boxes = [].slice.call(root.querySelectorAll('[data-step]'));
    if (!boxes.length) return;

    var countEl = root.querySelector('[data-count]');
    var totalEl = root.querySelector('[data-total]');
    var addBtn = root.querySelector('[data-add]');
    var msgEl = root.querySelector('[data-msg]');
    var fmt = (window.Shopify && Shopify.moneyFormat) || '';

    function money(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amount = whole + '.' + parts[1];
      if (!fmt) return '$' + amount;
      return fmt.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, amount);
    }

    // Same variant can appear in both the AM and PM routine. Buying one bottle
    // covers both uses, so collapse duplicates rather than adding quantity 2.
    function chosen() {
      var seen = {};
      boxes.forEach(function (b) {
        if (!b.checked) return;
        var id = b.getAttribute('data-variant');
        if (seen[id]) return;
        seen[id] = parseInt(b.getAttribute('data-price'), 10) || 0;
      });
      return seen;
    }

    function paint() {
      var map = chosen();
      var ids = Object.keys(map);
      var sum = ids.reduce(function (a, id) { return a + map[id]; }, 0);
      countEl.textContent = ids.length + (ids.length === 1 ? ' item' : ' items');
      totalEl.textContent = money(sum);
      addBtn.disabled = ids.length === 0;
      msgEl.textContent = '';
    }

    boxes.forEach(function (b) { b.addEventListener('change', paint); });

    addBtn.addEventListener('click', function () {
      var map = chosen();
      var items = Object.keys(map).map(function (id) {
        return { id: parseInt(id, 10), quantity: 1 };
      });
      if (!items.length) return;

      addBtn.disabled = true;
      msgEl.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
          return r.json();
        })
        .then(function () {
          msgEl.textContent = 'Added to your cart.';
          document.dispatchEvent(new CustomEvent('kinetics:cart:updated'));
          addBtn.disabled = false;
        })
        .catch(function (err) {
          msgEl.textContent = err.message;
          addBtn.disabled = false;
        });
    });

    paint();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinetics-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.kx-vids').forEach(function(sec){
      var track = sec.querySelector('[data-kx-track]');
      if(!track) return;
      sec.querySelectorAll('[data-kx-scroll]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var dir = parseInt(btn.getAttribute('data-kx-scroll'), 10);
          var card = track.querySelector('.kx-vids__card');
          var w = card ? card.offsetWidth + 18 : 260;
          track.scrollBy({ left: dir * w, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinetics-video-embeds"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kx-yt]');
    if (!btn) return;
    var id = btn.getAttribute('data-kx-yt');
    var frame = document.createElement('iframe');
    frame.className = 'kx-vemb__frame';
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    frame.title = btn.getAttribute('aria-label') || 'Video';
    frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    frame.allowFullscreen = true;
    btn.replaceWith(frame);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pv]');
    var form = document.getElementById('kx-product-form');
    var dataEl = document.querySelector('[data-pv-variants]');
    if (!root || !form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var groups = form.querySelectorAll('[data-pv-opt]');
    var idInput = form.querySelector('[data-pv-id]');
    var atc = form.querySelector('[data-pv-atc]');
    var atcLabel = form.querySelector('[data-pv-atc-label]');
    var priceEl = root.querySelector('[data-pv-price]');
    var barPrice = document.querySelector('[data-pv-bar-price]');
    var barBtn = document.querySelector('[data-pv-bar-btn]');
    var mainImg = root.querySelector('[data-pv-main]');
    var thumbs = root.querySelectorAll('[data-pv-thumb]');

    // The section nav and sticky columns sit under the site header when that
    // header is sticky, so measure it rather than guess.
    function setTop() {
      var h = document.querySelector('.shopify-section-group-header-group, header');
      var top = 0;
      if (h) {
        var cs = getComputedStyle(h);
        if (cs.position === 'sticky' || cs.position === 'fixed') top = h.getBoundingClientRect().height;
      }
      root.style.setProperty('--pv-top', top + 'px');
    }
    setTop();
    window.addEventListener('resize', setTop);

    var fmt = function (c) {
      return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : '$' + (c / 100).toFixed(2);
    };

    function showMedia(id) {
      if (!mainImg || !id) return;
      var t = root.querySelector('[data-pv-thumb][data-media-id="' + id + '"]');
      if (!t) return;
      mainImg.classList.add('is-swap');
      setTimeout(function () {
        mainImg.setAttribute('srcset', t.getAttribute('data-srcset') || '');
        mainImg.setAttribute('src', t.getAttribute('data-src'));
        mainImg.setAttribute('alt', t.getAttribute('data-alt') || '');
        mainImg.classList.remove('is-swap');
      }, 180);
      thumbs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
    }

    function chosen() {
      return Array.prototype.map.call(groups, function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function onChange() {
      var picks = chosen();
      groups.forEach(function (g, i) {
        var lab = g.querySelector('[data-pv-optval]');
        if (lab) lab.textContent = picks[i] || '';
      });
      var match = variants.find(function (v) {
        return picks.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; return; }
      idInput.value = match.id;
      atc.disabled = !match.available;
      atcLabel.textContent = match.available ? 'Add to cart' : 'Sold out';
      if (barBtn) { barBtn.disabled = !match.available; barBtn.textContent = atcLabel.textContent; }
      var html = '';
      if (match.compare_at_price && match.compare_at_price > match.price) html += '<s>' + fmt(match.compare_at_price) + '</s> ';
      html += '<span>' + fmt(match.price) + '</span>';
      if (priceEl) priceEl.innerHTML = html;
      if (barPrice) barPrice.textContent = fmt(match.price);
      showMedia(match.featured_media && match.featured_media.id);
      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
    form.addEventListener('change', function (e) {
      if (e.target.name && e.target.name.indexOf('pv-opt-') === 0) onChange();
    });

    // Clicking a shade's image selects that shade, so picture and choice never disagree.
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-media-id');
        var owner = variants.find(function (v) { return v.featured_media && String(v.featured_media.id) === String(id); });
        if (!owner) { showMedia(id); return; }
        groups.forEach(function (g, i) {
          var inp = g.querySelector('input[value="' + CSS.escape(owner.options[i]) + '"]');
          if (inp) inp.checked = true;
        });
        onChange();
      });
    });

    form.querySelectorAll('[data-pv-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = form.querySelector('input[name="quantity"]');
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-pv-step'), 10));
      });
    });

    // Palette: swatches fill the next empty Shade slot; each slot shows its colour.
    var shadeBtns = root.querySelectorAll('[data-pv-shade]');
    var slots = root.querySelectorAll('[data-pv-slot]');
    var hint = root.querySelector('[data-pv-shades-hint]');
    if (shadeBtns.length && slots.length) {
      var imgFor = {};
      shadeBtns.forEach(function (b) { imgFor[b.getAttribute('data-pv-shade')] = b.getAttribute('data-img') || ''; });
      function paint() {
        var picked = {};
        slots.forEach(function (sel) {
          var sw = sel.parentNode.querySelector('[data-pv-slot-sw]');
          var src = imgFor[sel.value];
          sw.style.backgroundImage = src ? 'url("' + src + '")' : '';
          if (sel.value) picked[sel.value] = true;
        });
        shadeBtns.forEach(function (b) { b.classList.toggle('is-picked', !!picked[b.getAttribute('data-pv-shade')]); });
        var full = Array.prototype.every.call(slots, function (sel) { return sel.value; });
        if (hint) {
          hint.textContent = full ? 'All 4 shades chosen. Change any of them below.' : 'Tap a shade to add it to your palette.';
          hint.classList.toggle('is-full', full);
        }
      }
      shadeBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var empty = Array.prototype.find.call(slots, function (sel) { return !sel.value; });
          if (!empty) { paint(); return; }
          empty.value = b.getAttribute('data-pv-shade');
          paint();
        });
      });
      slots.forEach(function (sel) { sel.addEventListener('change', paint); });
      paint();
    }

    // Clinical study images open at full size in a new tab.
    root.querySelectorAll('[data-pv-zoom] img').forEach(function (im) {
      im.addEventListener('click', function () {
        var src = (im.currentSrc || im.src).replace(/([?&])width=\d+&?/, '$1');
        window.open(src, '_blank', 'noopener');
      });
    });

    var bar = document.querySelector('[data-pv-bar]');
    if ('IntersectionObserver' in window) {
      if (bar && atc) {
        new IntersectionObserver(function (en) { bar.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0; },
          { rootMargin: '0px 0px -40px 0px' }).observe(atc);
      }
      var links = root.querySelectorAll('.pv-nav a');
      var spy = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting) return;
          links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + x.target.id); });
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      links.forEach(function (a) {
        var t = document.querySelector(a.getAttribute('href'));
        if (t) spy.observe(t);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
